import React from 'react';
import Keyboard from 'react-simple-keyboard';

const numberLayout = ['1 2 3 4 5 6 7 8 9 0 {bksp}', `- / : ( ) $ & @ " {enter}`, "{character} . , ? ! ' {smileys}", '{lowercase} {space} {uppercase}'];

const characterLayout = ['[ ] } { } # % ^ * + {bksp}', `_ \\ | ~ < > = $ & @ " {enter}`, "{number} . , ? ! ' {smileys}", '{lowercase} {space} {uppercase}'];

const lowercaseLayout = ['q w e r t y u i o p {bksp}', 'a s d f g h j k l {enter}', 'z x c v b n m {smileys}', '{uppercase} {space} {number}'];

const uppercaseLayout = ['Q W E R T Y U I O P {bksp}', 'A S D F G H J K L {enter}', 'Z X C V B N M , . {smileys}', '{lowercase} {space} {number}'];

const smileyLayout = [
  '😀 😊 😅 😂 🙂 😉 😍 😛 😠 😎 {bksp}',
  `😏 😬 😭 😓 😱 😪 😬 😴 😯 {enter}`,
  '😐 😇 🤣 😘 😚 😆 😡 😥 😓 🙄 {number}',
  '{lowercase} {space} {uppercase}',
];

const displayOverrides = {
  '{number}': '123',
  '{smileys}': '\uD83D\uDE03',
  '{uppercase}': 'ABC',
  '{lowercase}': 'abc',
  '{enter}': 'submit',
  '{bksp}': '⌫',
  '{space}': ' ',
  '{character}': '#+=',
};
// eslint-disable-next-line react/display-name
const ScreenKeyboard: React.FC<{ elementPosition: number }> = ({ elementPosition }) => {
  const [layoutName, setLayoutName] = React.useState('lowercase');

  React.useEffect(() => {
    const elements = document.getElementsByClassName('simple-keyboard') as HTMLCollectionOf<HTMLElement>;
    if (elements) {
      const keyboard = elements[0];
      keyboard.id = 'SCREEN_KEYBOARD';
      keyboard.classList.add('default_keyboard_styles');
      keyboard.style.zIndex = '100';
      keyboard.style.top = `${elementPosition + 18}px`;
    }
  }, [elementPosition]);

  const onKeyPress = (button: string) => {
    switch (button) {
      case '{uppercase}':
        setLayoutName('uppercase');
        break;
      case '{number}':
        setLayoutName('number');
        break;
      case '{character}':
        setLayoutName('character');
        break;
      case '{smileys}':
        setLayoutName('smiley');
        break;
      case '{lowercase}':
        setLayoutName('lowercase');
        break;
      case '{bksp}':
        handleBackSpace();
        break;
      case '{space}':
        handleChange(' ');
        break;
      case '{enter}':
        break;
      default:
        handleChange(button);
    }
  };

  const handleBackSpace = () => {
    const activeEl = document.activeElement as HTMLInputElement;
    if (activeEl) {
      let existingInput = activeEl.value;
      if (existingInput.length > 0) {
        const origStringArr = existingInput.split('');
        origStringArr.splice(existingInput.length - 1, 1);
        existingInput = origStringArr.join('');
        activeEl.value = existingInput;
        const event = new Event('input', { bubbles: true });
        activeEl.dispatchEvent(event);
      }
    }
  };

  const handleChange = (button: string) => {
    const activeEl = document.activeElement as HTMLInputElement;
    if (activeEl) {
      activeEl.value = `${activeEl.value}${button}`;
      const event = new Event('input', { bubbles: true });
      activeEl.dispatchEvent(event);
    }
  };

  return (
    <Keyboard
      maxLength={150}
      layoutName={layoutName}
      preventMouseDownDefault={true}
      preventMouseUpDefault={true}
      layout={{
        lowercase: lowercaseLayout,
        uppercase: uppercaseLayout,
        character: characterLayout,
        number: numberLayout,
        smiley: smileyLayout,
      }}
      onKeyPress={(button: string) => onKeyPress(button)}
      display={displayOverrides}
      buttonTheme={[
        {
          class: 'SCREEN_KEYBOARD_SUBMIT',
          buttons: '{enter}',
        },
      ]}
    />
  );
};

export default ScreenKeyboard;
